"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = require("prop-types");
const ui_theme_1 = require("@kyruus/ui-theme");
const styles_1 = require("./styles");
const BookableLocation_1 = __importDefault(require("./BookableLocation"));
const NonBookableLocation_1 = __importDefault(require("./NonBookableLocation"));
const propTypes = {
    bookableLocations: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
        id: (0, prop_types_1.oneOfType)([prop_types_1.string, prop_types_1.number]),
        name: prop_types_1.string,
        street1: prop_types_1.string,
        street2: prop_types_1.string,
        suite: prop_types_1.string,
        city: prop_types_1.string,
        state: prop_types_1.string,
        zip: prop_types_1.string
    })).isRequired,
    nonBookableLocations: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
        id: prop_types_1.string,
        name: prop_types_1.string,
        street1: prop_types_1.string,
        street2: prop_types_1.string,
        suite: prop_types_1.string,
        city: prop_types_1.string,
        state: prop_types_1.string,
        zip: prop_types_1.string
    })).isRequired,
    /**
     * @callback
     * @param {String} id
     */
    onSelect: prop_types_1.func.isRequired,
    /**
     * @callback
     * @param {String} id
     */
    onMouseEnter: prop_types_1.func.isRequired,
    /**
     * @callback
     * @param {String} id
     */
    onMouseLeave: prop_types_1.func.isRequired,
    selectedLocationIds: (0, prop_types_1.instanceOf)(Set).isRequired,
    activeLocationId: prop_types_1.string,
    handleOnFocus: prop_types_1.func.isRequired,
    handleOnBlur: prop_types_1.func.isRequired
};
const makeNameFromLocation = () => {
    let index = 0;
    return (name, street1) => {
        index++;
        return name ? `${index}. ${name}` : `${index}. ${street1}`;
    };
};
const Locations = (0, ui_theme_1.withTheme)(({ bookableLocations, nonBookableLocations, onMouseEnter, onMouseLeave, handleOnFocus, handleOnBlur, selectedLocationIds, onSelect, theme, activeLocationId = '', locationId }) => {
    const formatLocName = makeNameFromLocation();
    const activeLocationStyle = {
        background: theme.color_background_hover
    };
    const findSelectedIdInBookableLocations = bookableLocations.find((loc) => loc.id.toString() === locationId);
    return (react_1.default.createElement(styles_1.List, { "data-testid": "ProviderLocations__Locations", className: "ProviderLocationsList" },
        bookableLocations.map((loc) => {
            let isSelected, disabled;
            if (findSelectedIdInBookableLocations === null || findSelectedIdInBookableLocations === void 0 ? void 0 : findSelectedIdInBookableLocations.id) {
                isSelected = loc.id.toString() === locationId;
                disabled = isSelected;
            }
            else {
                isSelected = selectedLocationIds.has(loc.id);
                disabled = selectedLocationIds.size === 1 && isSelected;
            }
            return (react_1.default.createElement("li", { key: loc.id, onMouseEnter: () => onMouseEnter(loc.id), onMouseLeave: () => onMouseLeave(loc.id), style: loc.id === activeLocationId ? activeLocationStyle : {}, onFocus: () => handleOnFocus(loc.id), onBlur: handleOnBlur },
                react_1.default.createElement(BookableLocation_1.default, Object.assign({ disabled: disabled, isSelected: isSelected, onSelect: onSelect }, loc, { name: formatLocName(loc.name, loc.street1) }))));
        }),
        nonBookableLocations.map((loc) => (react_1.default.createElement("li", { key: loc.id, onMouseEnter: () => onMouseEnter(loc.id), onMouseLeave: () => onMouseLeave(loc.id), style: loc.id === activeLocationId ? activeLocationStyle : {}, onFocus: () => handleOnFocus(loc.id), onBlur: handleOnBlur },
            react_1.default.createElement(NonBookableLocation_1.default, Object.assign({}, loc, { name: formatLocName(loc.name, loc.street1) })))))));
});
Locations.defaultProps = {
    activeLocationId: ''
};
Locations.propTypes = propTypes;
exports.default = Locations;
//# sourceMappingURL=Locations.js.map